/**
 * SectionTemplate Component
 */

import * as React from 'react';
import './styles.scss';

const SectionTemplate = ({ children, id }) => (
  <div className="main__section" data-section-id={id}>
    {children}
  </div>
);

export default SectionTemplate;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/templates/Section/index.tsx